import { dmApi } from "../../../app/dmApi";
import {
  getAuthorizationHeader,
  handleQueryError,
  handleQueryErrorAndSuccess,
} from "../../../helpers/RtkQueryUtils";
import { serialize } from "../../../helpers/Utils";

export const cartApi = dmApi.injectEndpoints({
  endpoints: (build) => ({
    getCartSummaryOverview: build.query({
      query: (data) => {
        const paramData = serialize(data);
        return {
          url: `/cart-summary-overview?${paramData}`,
          method: "GET",
          headers: getAuthorizationHeader(),
        };
      },
      providesTags: ["cartSummaryOverview"],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryError(queryFulfilled);
      },
    }),

    getUsedCartLog: build.query({
      query: (data) => {
        const paramData = serialize(data);
        return {
          url: `/used-cart-log?${paramData}`,
          method: "GET",
          headers: getAuthorizationHeader(),
        };
      },
      providesTags: ["usedCartLog"],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryError(queryFulfilled);
      },
    }),

    createCartMaterial: build.mutation({
      query: (requestBody) => ({
        url: `/cart-material/create`,
        method: "POST",
        headers: getAuthorizationHeader(),
        body: requestBody,
      }),
      invalidatesTags: ["usedCartLog", "cartSummaryOverview" ,'mixingCartList'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Cart Material");
      },
    }),

    updateCartMaterial: build.mutation({
      query: ({ id, requestBody }) => ({
        url: `/cart-material/update/${id}`,
        method: "PUT",
        headers: getAuthorizationHeader(),
        body: requestBody,
      }),
      invalidatesTags: ["usedCartLog", "cartSummaryOverview" ,"mixingCartList"],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Cart Material");
      },
    }),

    getCartWasteMaterial: build.query({
      query: (data) => {
        const paramData = serialize(data);
        return {
          url: `/get-cart-waste-material?${paramData}`,
          method: "GET",
          headers: getAuthorizationHeader(),
        };
      },
      providesTags: ["cartWasteMaterial"],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryError(queryFulfilled);
      },
    }),

    createCartWasteMaterial: build.mutation({
      query: (requestBody) => ({
        url: `/cart-waste-material/create`,
        method: "POST",
        headers: getAuthorizationHeader(),
        body: requestBody,
      }),
      invalidatesTags: ["cartWasteMaterial", "cartSummaryOverview"],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Cart Waste Material");
      },
    }),

    getCartPendingLog: build.query({
      query: (data) => {
        const paramData = serialize(data);
        return {
          url: `/get-cart-pending-log?${paramData}`,
          method: "GET",
          headers: getAuthorizationHeader(),
        };
      },
      providesTags: ["cartPendingLog"],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryError(queryFulfilled);
      },
    }),

    createCartPending: build.mutation({
      query: (requestBody) => ({
        url: `/cart-pending-create`,
        method: "POST",
        headers: getAuthorizationHeader(),
        body: requestBody,
      }),
      invalidatesTags: ["cartPendingLog", "cartSummaryOverview"],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Cart Pending");
      },
    }),
  }),
});

export const {
  useGetCartSummaryOverviewQuery,
  useGetUsedCartLogQuery,
  useCreateCartMaterialMutation,
  useUpdateCartMaterialMutation,
  useGetCartWasteMaterialQuery,
  useCreateCartWasteMaterialMutation,
  useGetCartPendingLogQuery,
  useCreateCartPendingMutation,
} = cartApi;
